module.exports = __webpack_public_path__ + "static/media/bottomTriangle.b9c3f551.svg";